import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';

export const RadioField = ({ label, input, meta, wrapperAttributes, wrapperTag, suppressErrorMessage, options }) => {
  const fieldId = `${input.name}_field`;
  const hasError = meta.error && meta.touched && !meta.active;

  const classes = {
    'form__input--error': hasError,
  };

  const inputElements = Object.keys(options).map(option => (
    <Fragment key={option}>
      <input
        {...input}
        className={classNames(classes)}
        type="radio"
        id={`${fieldId}_${option}`}
        checked={option === input.value}
        value={option}
      />
      <label htmlFor={`${fieldId}_${option}`} className="form__label--no-style">
        {options[option]}
      </label>
    </Fragment>
  ));

  return React.createElement(
    wrapperTag || 'div',
    wrapperAttributes || {},
    label ? <label htmlFor={fieldId}>{label}</label> : null,
    <div className="form__radio">{inputElements}</div>,
    hasError && !suppressErrorMessage ? <div className="error__text text--sm mt-">{meta.error}</div> : null
  );
};

RadioField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.element,
  suppressErrorMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string,
  options: PropTypes.object,
};
